module.exports = __webpack_public_path__ + "static/media/Puerta de paso.3c83a514.jpg";